<script lang="ts" setup>
interface Props {
  heading: string;
  body: string;
  theme?: 'normal' | 'alternative';
  first: boolean;
}

withDefaults(defineProps<Props>(), {
  first: false,
});

</script>

<template>
  <div :class="{ 'bg-gray-50 py-8': theme === 'alternative' }">
    <v-container>
      <component :is="first ? 'h1' : 'h2'"  class="text-2xl lg:text-3xl xl:text-4xl font-bold text-gray-900 mb-6">
        {{ heading }}
      </component>
      <div
        v-if="body"
        v-html="body"
        class="prose max-w-none"
        :class="{ 'text-gray-700': theme === 'alternative', 'text-gray-900': theme !== 'normal' }"
      />
    </v-container>
  </div>
</template>
